import { createCtx } from "@/hooks/createCtx";
import {
  ErrorStatuses,
  InfoStatuses,
  SuccessStatuses,
} from "@/types/enums/paymentStatus.enum";
import { LastPayment } from "@/types/payment";
import { localStoragePaymentRef } from "@/utils/localStorage";
import React, { ReactNode, useState } from "react";

interface PaymentState {
  paymentCheckStatus:
    | SuccessStatuses
    | ErrorStatuses
    | InfoStatuses
    | "server_error"
    | undefined;
  lastPayment: LastPayment | null;
}

interface PaymentContextType extends PaymentState {
  setPaymentCheckStatus: (
    paymentCheckStatus:
      | SuccessStatuses
      | ErrorStatuses
      | InfoStatuses
      | "server_error"
  ) => void;
  setLastPayment: (payment: LastPayment | null) => void;
}

const [usePaymentContext, PaymentProvider] = createCtx<PaymentContextType>();

export { usePaymentContext };

export const PaymentContextProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [paymentCheckStatus, setPaymentCheckStatus] = useState<
    SuccessStatuses | ErrorStatuses | InfoStatuses | "server_error" | undefined
  >();
  const [lastPayment, setLastPayment] = useState<LastPayment | null>(null);

  return (
    <PaymentProvider
      value={{
        paymentCheckStatus,
        lastPayment,
        setPaymentCheckStatus,
        setLastPayment: (payment: LastPayment | null) => {
          if (!lastPayment) {
            localStoragePaymentRef.removeLastPayment();
          }
          setLastPayment(payment);
        },
      }}
    >
      {children}
    </PaymentProvider>
  );
};
